import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';

export type CommentsModalProps = {
    data: {
        comment: string,
        createdBy: string,
        activity: string,
        fromNode: string,
        toNode: string,
        fromNodeStr: string,
        toNodeStr: string,
        variantType: string,
        filterSummary: any,
        type: string,
        component: string,
        mode: string,
        source: string,
    }
}


export const openCommentsModal = ({ data }:  CommentsModalProps) => {
    getEventEmitter().emit(Event.openCommentsModal, { data });
};
